import styled, { css } from 'styled-components';

export const Content = styled.div(
  () => css`
    flex: 1;
  `,
);

export const Layout = styled.div(
  ({ theme }) => css`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: ${theme.co.neutral99};
  `,
);
